/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";

const SaveModulePopup = ({
  afterPopupCLose = () => {},
  moduleId,
  setModuleId,
  parentModules,
}) => {
  const titleRef = useRef(null);

  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [isRoot, setIsRoot] = useState(false);
  const [parentValue, setParentValue] = useState(null);
  const [parentId, setParentId] = useState(null);
  const [isFeatured, setIsFeatured] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  /* hook for validation */
  const [errors, setErrors] = useState({});

  /* function to validate form */
  const validation = () => {
    const newErrors = {};

    if (name.trim() === "") {
      newErrors.name = t("A name for the module is required.");
    }

    if (slug.trim() === "") {
      newErrors.slug = t("A unique, URL-friendly slug is required.");
    }

    if (isRoot === false && parentValue === null) {
      newErrors.parent = t(
        "If this is not a root module, a parent must be selected."
      );
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      if (newErrors.name && titleRef.current) {
        setTimeout(() => {
          titleRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          titleRef.current.setAttribute("tabindex", "-1");
          titleRef.current.focus();
        }, 100);
      }
    }

    return Object.keys(newErrors).length === 0;
  };

  //parent selection
  const parentSelectionHandler = (val) => {
    setErrors((prev) => ({ ...prev, parent: "" }));
    if (val) {
      setParentValue(val);
      setParentId(val.value);
    } else {
      setParentValue(null);
      setParentId(null);
    }
  };

  //get details
  const getDetails = async () => {
    setIsLoadingDetails(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MODULE_DETAILS +
        `/${moduleId}` +
        ``;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setName(response.data.name || "");
        setSlug(response.data.slug || "");
        setIsRoot(response.data.isroot || false);
        parentSelectionHandler(response.data.parentdata || null);
        setIsFeatured(response.data.isfeatured || false);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoadingDetails(false);
    }
  };

  //function for create new tag
  const saveModuleHandler = async () => {
    if (!validation()) {
      return;
    }

    setIsSaving(true);
    try {
      let sendingData = {
        name,
        slug,
        isroot: isRoot,
        parent: parentId,
        isfeatured: isFeatured,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (moduleId) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_MODULE +
          `/${moduleId}` +
          ``;

        response = await putData(requestUrl, sendingData);
      } else {
        requestUrl = requestUrl + url.API_CREATE_MODULE;

        response = await postData(requestUrl, sendingData);
      }

      setIsSaving(false);
      console.log(response);

      if (response.status) {
        // close the modal of addLabel
        if (window.bootstrap && window.bootstrap.Offcanvas) {
          const offcanvasElement = document.querySelector("#saveModule");
          const offcanvasInstance =
            window.bootstrap.Offcanvas.getInstance(offcanvasElement);
          if (offcanvasInstance) {
            offcanvasInstance.hide();
          }
        }
        resetHandler();
        afterPopupCLose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSaving(false);
    }
  };

  /* reset */
  const resetHandler = () => {
    setName("");
    setSlug("");
    setParentValue(null);
    setParentId(null);
    setIsRoot(true);
    setIsFeatured(false);
    setModuleId(null);
    setErrors({});
    setIsSaving(false);
    setIsLoadingDetails(false);
  };

  useEffect(() => {
    if (moduleId) {
      getDetails();
    } else {
      resetHandler();
    }
  }, [moduleId]);

  useEffect(() => {
    setIsRoot(true);
  }, []);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveModule"
      aria-labelledby="saveModule"
    >
      {/* Header design similar to SaveFeedbackRulePopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              category
            </span>{" "}
            {/* Using 'category' icon as a placeholder */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {moduleId ? t("Edit Module") : t("Create Module")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {moduleId
                ? t("Manage existing module details")
                : t("Define a new module")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {isLoadingDetails && (
          <div className="d-flex flex-column justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 z-index-1050">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">
                {t("Loading module details...")}
              </span>
            </div>
            <p className="text-primary mt-3 fw-bold">
              {t("Loading module details...")}
            </p>
          </div>
        )}
        {/* Professional Card Layout */}
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* Title */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="labelName"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  ref={titleRef}
                  type="text"
                  id="labelName"
                  className={`form-control fs-sm shadow-none ${
                    errors.name ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., User Management")}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (errors.name) {
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }
                  }}
                  aria-describedby="titleFeedback"
                />
                {/* level warning */}
                {errors.name && (
                  <div id="titleFeedback" className="invalid-feedback">
                    {errors.name}
                  </div>
                )}
              </div>

              {/* slug */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="slugID"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Slug")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="slug"
                  className={`form-control fs-sm shadow-none ${
                    errors.slug ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., user-management")}
                  value={slug}
                  onChange={(e) => {
                    setSlug(e.target.value);
                    if (errors.slug) {
                      setErrors((prev) => ({ ...prev, slug: "" }));
                    }
                  }}
                  aria-describedby="slugFeedback"
                />
                {/* slug warning */}
                {errors.slug && (
                  <div id="slugFeedback" className="invalid-feedback">
                    {errors.slug}
                  </div>
                )}
              </div>

              {/* is root */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                  <input
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    type="checkbox"
                    id="isRoot"
                    checked={isRoot}
                    onChange={(e) => {
                      if (e.target.checked) {
                        parentSelectionHandler(null);
                        setErrors((prev) => ({ ...prev, parent: "" }));
                      }
                      setIsRoot(e.target.checked);
                    }}
                  />
                  <label
                    className="form-check-label fw-semibold text-dark"
                    htmlFor="isRoot"
                  >
                    {t("Is Root")}
                  </label>
                </div>
              </div>

              {/* select parent */}
              {isRoot ? null : (
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="parentModuleSelect" // Unique ID for accessibility
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Select Parent")} <span className="text-danger">*</span>
                  </label>
                  <Select
                    inputId="parentModuleSelect" // Connects label to the Select input
                    isClearable
                    placeholder={t("Choose a parent module...")}
                    options={parentModules}
                    value={parentValue}
                    onChange={(val) => parentSelectionHandler(val)}
                    styles={reactSelectStyle("3px", "6px", true, false)}
                  />
                  {errors.parent && (
                    <div className="invalid-feedback d-block">
                      {errors.parent}
                    </div>
                  )}
                </div>
              )}

              {/* is featured */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                  <input
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    type="checkbox"
                    id="isFeatured"
                    checked={isFeatured}
                    onChange={(e) => setIsFeatured(e.target.checked)}
                  />
                  <label
                    className="form-check-label fw-semibold text-dark"
                    htmlFor="isFeatured"
                  >
                    {t("Is Featured")}
                  </label>
                </div>
              </div>
            </div>
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveModuleHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Module")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveModulePopup;
